<template>
  <actionable-menu
      ref="menu"
      v-bind="$attrs"
  >
    <nav-list-item
        icon="edit"
        label="Bewerken"
        route-name="/uitloggen"
    />
    <nav-list-item
        icon="content_copy"
        label="Dupliceren"
        route-name="/uitloggen"
    />
    <nav-list-item
        icon="redo"
        label="Delen"
        route-name="/uitloggen"
    />
    <q-separator />
    <nav-list-item
        icon="delete_outline"
        label="Verwijderen"
        route-name="/uitloggen"
    />
  </actionable-menu>
</template>

<script>
export default {
  props: ['item'],
  methods: {
    show() {
      this.$refs.menu.show()
    },
  }
}
</script>
